import { render } from "./TableReprovado.vue?vue&type=template&id=799333d9&scoped=true"
import script from "./TableReprovado.vue?vue&type=script&lang=js"
export * from "./TableReprovado.vue?vue&type=script&lang=js"

import "./TableReprovado.vue?vue&type=style&index=0&id=799333d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799333d9"]])

export default __exports__